import { useEffect, useState } from "react";
import "./DataSourceDropdown.scss";
import { icons } from "../../../components/common/utilities";
import { useDispatch } from "react-redux";
import { SET_IS_DATABASE, SET_SELECTED_DATA_TAG_SOURCE_ID } from "../DataTagConstants";

export default function DataSourceDropdown({
  dataSourceDetails,
  dataNodesDetails,
}) {
  const dataSource = (dataSourceDetails || []).filter(
    (item) => item?.typeCode !== "IAM_SERVICE"
  );

  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);

  // Default selected = first node
  const [selectedNode, setSelectedNode] = useState(null);

  useEffect(() => {
  if (!selectedNode && dataSource.length > 0) {
    setSelectedNode(dataSource[0]);
    dispatch({
      type: SET_SELECTED_DATA_TAG_SOURCE_ID,
      payload: {
        id: dataSource[0].dataSourceId,
        type: dataSource[0].typeCode, 
      }
    });
    dispatch({type: SET_IS_DATABASE, payload: dataSource[0].isDatabase})
  }
}, [dataSource, selectedNode, dispatch]);


  const toggleDropdown = () => setOpen(!open);

  const handleSelect = (item) => {
    setSelectedNode(item);
    dispatch({
      type: SET_SELECTED_DATA_TAG_SOURCE_ID,
      payload: {
        id: item.dataSourceId,
        type: item.typeCode,
      }
    });
    dispatch({type: SET_IS_DATABASE, payload: item.isDatabase})
    setOpen(false);
  };

  return (
    <div className="ds-dropdown-container">
      <div className="ds-dropdown-header" onClick={toggleDropdown}>
        <div className="left-section" title={selectedNode?.name}>
          <img
            src={icons[selectedNode?.typeCode] || icons["OTHER"]}
            alt="icon"
            className="ds-icon"
          />
          <span className="ds-title">{selectedNode?.name}</span>
        </div>
        <span className={`arrow ${open ? "rotate" : ""}`}>&#9662;</span>
      </div>

      {open && (
        <div className="ds-dropdown-list">
          {dataSource.map((item) => (
            <div
              key={item.dataSourceId}
              className="ds-item"
              onClick={() => handleSelect(item)}
              title={item?.name}
            >
              <img
                src={icons[item.typeCode] || icons["OTHER"]}
                alt="icon"
                className="ds-item-icon"
              />
              <span className="ds-sub-title">{item?.name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
